import Vue from 'vue';

import { assign } from 'lodash';
import * as api from 'api/api-persons';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  PersonsList: state => type => state[type],
};

const actions = {
  GetPersonsList({ commit }, params) {
    const type = params.type;
    const query = params.query;

    commit(types.FETCH_PERSONS_LIST_START, { type });
    api.getPersons(
      type,
      query,
      (response) => {
        commit(types.RECEIVE_PERSONS_LIST, { type, response });
      },
      (description, status, error) => {
        commit(types.FETCH_PERSONS_LIST_ERROR, { type, error });
      },
    );
  },
  ClearPersonsList({ commit }, { type }) {
    commit(types.CLEAR_PERSONS_LIST_STORE, { type });
  },
};

const mutations = {
  [types.FETCH_PERSONS_LIST_START](state, { type }) {
    if (state[type]) Vue.set(state, type, assign(state[type], neutralState, { fetching: true }));
    else Vue.set(state, type, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PERSONS_LIST_ERROR](state, { type, error }) {
    Vue.set(state, type, assign(state[type], neutralState, { error }));
  },
  [types.RECEIVE_PERSONS_LIST](state, { type, response }) {
    Vue.set(state, type, assign(state[type], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },
  [types.CLEAR_PERSONS_LIST_STORE](state, { type }) {
    Vue.set(state, type, assign({}, initState));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/persons/entities/persons-list.js